import { Link } from "react-router-dom/cjs/react-router-dom";
import offerlogo from "../../../assets/images/offer-logo.png";
import bg from "../../../assets/images/bg.png";
import "./style.scss";
import { useSelector } from "react-redux";
import React from "react";
import { Card, CardBody, CardImg, CardText } from "reactstrap";
import compoundImg from "assets/images/bg.png";
import { useTranslation } from "react-i18next";

const SpecialCard = ({ data }) => {
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.Auth?.lang);
	const currency = useSelector((state) => state.Auth?.currency?.currency_code);
	const AuthData = useSelector((state) => state.Auth);

	return (
		<React.Fragment>
			<div className="websitPages specialCard" onClick={() => checkAuth()}>
				<div className="position-relative projectName">
					<p className="offer">
						{data?.amount_requested?.toLocaleLowerCase() === "percentage"
							? data?.discount
							: toCurrency(data?.discount)}
						{data?.amount_requested?.toLocaleLowerCase() === "percentage"
							? "%"
							: ` ${currency}`}{" "}
						<span style={{ fontSize: "14px", fontWeight: "400" }}>
							Discount
						</span>
					</p>
					{/* <i className="fa cursor-pointer bgheartResale fa-heart" /> */}
					<Card className="comCard">
						{data?.compound?.images?.length > 0 ? (
							data?.compound?.images?.map((img, index) => {
								if (index === 0) {
									return <CardImg key={index} src={img?.path}></CardImg>;
								}
							})
						) : (
							<CardImg src={compoundImg}></CardImg>
						)}

						<CardBody>
							<CardText
								tag="h4"
								style={{ fontWeight: 800 }}
								className="text-card gotham-font mb-0 font-size-24">
								{data?.compound?.name[`${AuthData?.lang}`]
									? data?.compound?.name[`${AuthData?.lang}`]
									: data?.compound?.name?.en}
							</CardText>

							<CardText
								tag="p"
								// style={{height: '21px'}}
								className="text-card fw-medium gotham-font font-size-16">
								{data?.compound?.area?.name[AuthData?.lang]}
							</CardText>

							{/* <CardText
								tag="p"
								className="font-size-14 text-card gotham-font h-55 com-description">
								{data?.description[AuthData?.lang]
									? data?.description[AuthData?.lang]
									: data?.description?.en}
							</CardText> */}
							<hr />
							<CardText tag="h6" className="font-size-14 text-card gotham-font">
								{data?.installmen &&
									t("up to installment", {
										num: Number(data?.installment),
									})}
							</CardText>

							<CardText tag="h5" className="font-size-14 text-card">
								{t("Installements up to")} {data?.payment_year?.years}{" "}
								{t("years")}
							</CardText>
							<CardText tag="h2" className="pb-2 d-flex text-card">
								<span className="font-size-14 pe-3">{t("starting from")} </span>
								{/* <span className="font-size-24 fw-bold">
									{" "}
									{toCurrency(data?.starting_from)}{" "}
								</span> */}
							</CardText>
							<button className="btn btnMoreInfo mt-4">
								{t("More Information")}
							</button>
						</CardBody>
					</Card>
				</div>
			</div>
			{/* <AuthCard modal={modal} setModal={setModal} history={history} location={location} /> */}
		</React.Fragment>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default SpecialCard;
